module.exports = __webpack_public_path__ + "img/00036.33d29e33.webp";